import React from "react";
import styled from "styled-components";
const powerGoLogoSmall = require("../../assets/images/img_powerfly_logo.png");
const powerGoLogoBig = require("../../assets/images/img_powerfly_logo.png");

const PowerGoAndSubheader = () => {
  return (
    <PowerGoAndSubheaderWrapper>
      <ImgResponsiveBig src={powerGoLogoBig} />
      <ImgResponsiveSmall src={powerGoLogoSmall} />
    </PowerGoAndSubheaderWrapper>
  );
};

export default PowerGoAndSubheader;

const PowerGoAndSubheaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ImgResponsiveBig = styled.img`
  height: auto;
  max-width: 100%;
  @media only screen and (max-height: 768px) {
    display: none;
  }
  @media only screen and (max-width: 500px) {
    display: none;
  }
`;
const ImgResponsiveSmall = styled.img`
  display: none;
  @media only screen and (max-height: 768px) {
    display: block;
    width: 13rem;
  }
  @media only screen and (max-width: 500px) {
    display: block;
    width: 13rem;
  }
`;
